var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/~/lodash/_Symbol.js
// module id = 494
// module chunks = 0